import { useState, useCallback } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import type { Location } from 'history';
type UpdateUrlParams = {
  location: Location;
  documentId?: string | null;
  fileId?: string | null;
};

const updateUrlParams = ({ location, documentId, fileId }: UpdateUrlParams) => {
  const searchParams = new URLSearchParams(location.search);

  if (documentId) {
    searchParams.set('documentId', documentId);
  } else {
    searchParams.delete('documentId');
  }

  if (fileId) {
    searchParams.set('fileId', fileId);
  } else {
    searchParams.delete('fileId');
  }

  return searchParams.toString();
};

export const useDocumentView = () => {
  const location = useLocation();
  const history = useHistory();
  const [previewVisible, setDocumentPreview] = useState<boolean>(false);
  const [sidebarVisible, setDocumentSidebar] = useState<boolean>(false);

  const updateUrl = useCallback(
    (documentId?: string | null, fileId?: string | null) => {
      history.push({
        ...location,
        search: updateUrlParams({ location, documentId, fileId }),
      });
    },
    [history, location],
  );

  const handlePreviewClose = useCallback(() => {
    setDocumentPreview(false);
    updateUrl(null);
  }, [updateUrl]);

  const handleSideBarClose = useCallback(() => {
    setDocumentSidebar(false);
    updateUrl(null);
  }, [updateUrl]);

  const handleDownload = (url?: string) => {
    if (url) {
      window.open(url, '_blank');
    }
  };

  return {
    previewVisible,
    setDocumentPreview,
    sidebarVisible,
    setDocumentSidebar,
    handlePreviewClose,
    handleSideBarClose,
    handleDownload,
    updateUrl,
  };
};
